/**
 * Impostazioni del canale (Task 47): etichette e testi d'aiuto condivisi tra la
 * pagina del responsabile di canale (area rappresentante) e il form canale
 * dell'admin. Per aggiungere un interruttore basta una riga qui (la chiave deve
 * esistere in `ChannelSettings`): entrambe le pagine lo mostrano.
 */
import type { ChannelSettings } from '../../services/supportApi';

export type ChannelSettingKey = keyof ChannelSettings;

export interface ChannelSettingField {
  key: ChannelSettingKey;
  label: string;
  hint: string;
}

export const CHANNEL_SETTING_FIELDS: ChannelSettingField[] = [
  {
    key: 'notifyAssigneeOnStatus',
    label: "Avvisa l'assegnatario quando cambia lo stato del ticket",
    hint: 'Email secondo le preferenze di ciascun assegnatario; non a chi fa il cambio',
  },
  {
    key: 'notifyRequesterOnStatus',
    label: 'Avvisa il richiedente quando cambia lo stato',
    hint: "Email all'associato per presa in carico, in lavorazione, in attesa e chiusura; mai dal canale di smistamento",
  },
  {
    key: 'showOperatorName',
    label: 'Mostra il nome del rappresentante che risponde',
    hint: "L'associato vede “Nome Cognome · Canale” invece del solo nome del canale",
  },
  {
    key: 'mentionEmailImmediate',
    label: "Invia subito l'email a chi viene menzionato",
    hint: 'Ignora fascia oraria e riepilogo del menzionato; chi ha scelto “nessuna email” non la riceve comunque',
  },
  {
    key: 'anyMemberApprovesDrafts',
    label: 'Tutti i componenti possono approvare le bozze',
    hint: 'Spento: approvano solo i responsabili del canale e gli amministratori. Acceso: anche ogni componente che può rispondere e ha il permesso di gestire i ticket (associativa.supporto.handle); mai chi è stato invitato nel ticket',
  },
];

/** Valore di un'impostazione: assente (canali storici, mock) = spento. */
export const settingValue = (settings: Partial<ChannelSettings> | null | undefined, key: ChannelSettingKey): boolean =>
  Boolean(settings && settings[key]);
